import { STRIPE } from "./config-global";

export const STRIPE_PLANS = [
    {
        id: STRIPE.monthly_id,
        subscription: 'Monthly',
        price: 99.00
    },
    {
        id: STRIPE.yearly_id,
        subscription: 'Annual',
        price: 900.00
    }
];

export const RESPONSE_STATUS_SUCCESS = 'success';

export const SALES_RUSH = {
    id: '407a2c2de8414b91b02f',
    firstname: 'Sales',
    lastname: 'Rush',
};

export const TYPESENSE_TOKEN_SEPARATOR = 'empty-string';

export const PAYMENT_STRIPE_STATUS = ['canceled', 'paused', 'past_due'];

export const DEFAULT_PERMISSION_SET_NAME = 'Default';

export const DEFAULT_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const SCHEDULED_ACTION_STATUS = [
    { id: 'x04svdXl', value: 'scheduled', label: 'Scheduled', icon: 'bx:calendar-event' },
    { id: 'Tz6pQ1vR', value: 'in_progress', label: 'In Progress', icon: 'mdi:progress-clock' },
    { id: 'rJLytL4v', value: 'completed', label: 'Completed', icon: 'akar-icons:check' },
    { id: 'Gk3nW7yD', value: 'canceled', label: 'Canceled', icon: 'mdi:cancel' },
];

export const ACTION_PRIORITY = [
    { id: 'Hq7kR2mN', value: 'high', label: 'High', color: 'error.main' },
    { id: 'Mv4tY8pL', value: 'medium', label: 'Medium', color: 'warning.main' },
    { id: 'Lw9cB3xS', value: 'low', label: 'Low', color: 'success.main' },
];

export const RECOMMENDED_ACTION_STATUS = [
    { id: 'Ah4nQ7tK', value: 'pending', label: 'Pending' },
    { id: 'Bz8rM2wF', value: 'scheduled', label: 'Scheduled' },
    { id: 'Cx3vL9pD', value: 'fulfilled', label: 'Fulfilled' },
    { id: 'Dk6yT1hS', value: 'ignored', label: 'Ignored' },
    { id: 'Ej2wG5nR', value: 'superseded', label: 'Superseded' },
    { id: 'Fq9mB4cV', value: 'expired', label: 'Expired' },
];

export const IGNORE_REASON = [
    { id: 'Gt5kW8zA', value: 'not_needed', label: 'Not needed' },
    { id: 'Hn1pX6rJ', value: 'wrong_timing', label: 'Wrong timing' },
    { id: 'Iv7dC3yM', value: 'other', label: 'Other' },
];

export const SCHEDULED_ACTION_COMPLETION_METHOD = [
    { id: 'Jr4fN9sB', value: 'disposition', label: 'Completed with disposition' },
    { id: 'Ks8hZ2qE', value: 'no_disposition', label: 'Completed without disposition' },
    { id: 'Lm3tV7wG', value: 'auto_activity_match', label: 'Auto-completed from activity' },
];

export const EVALUATION_STATE = [
    { id: 'Rd5vK8nQ', value: 'idle', label: 'Up to date' },
    { id: 'Yb2mT6wJ', value: 'queued', label: 'Analyzing…' },
    { id: 'Pc9xF3hL', value: 'blocked_budget', label: 'AI allowance reached' },
    { id: 'Ns4gW7zE', value: 'failed', label: "Couldn't update" },
];

export const EXCLUSION_REASON = [
    { id: 'Ve6jH1rD', value: 'profile_unavailable', label: 'Intelligence not available for this record' },
    { id: 'Qk8pZ2sM', value: 'record_inactive', label: 'Intelligence not available for inactive records' },
];

export const INTELLIGENCE_DIRECTION = [
    { id: 'Ft3yN9cB', value: 'increasing', label: 'Increasing', icon: 'eva:trending-up-fill', color: 'success.main' },
    { id: 'Ju7aX4kR', value: 'stable', label: 'Stable', icon: 'eva:arrow-forward-fill', color: 'text.secondary' },
    { id: 'Wm1eS5vG', value: 'declining', label: 'Declining', icon: 'eva:trending-down-fill', color: 'error.main' },
];
